import './header.css'
import { HiOutlineMenu, HiUserCircle } from "react-icons/hi";

export default function Header() {
  return (
    <div className="header">
      <HiOutlineMenu className="icon left" />

      <p className="title">Salão do Seu Manoel</p>

      <HiUserCircle className="icon right" />
    </div>
  );
}